import React, { useState, useRef, useEffect } from 'react'
import _ from "lodash"
import {
    Input,
    FormGroup,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText
} from "reactstrap"
import { useTranslation } from 'react-i18next'
import classnames from 'classnames';

import { getImageUrl } from "dbHandler"
import Modal from "main_views/components/Modal2"
import RequestsForms from 'main_views/form/request'
import Form from 'main_views/components/Form/form_v2'

function MessageModal(props) {

    let { t } = useTranslation()

    let { isOpen, toggle, task, isDecline,isComplete, completeTicket, approveTicket, declineTicket } = props

    let [note, setNote] = useState('')
    let [isSaving, setIsSaving] = useState(false)

    let [activeTab, setActiveTab] = useState()
    let [answerFormData, setAnswerFormData] = useState()

    let requestModalRef = useRef()

    // clear answerFormData
    useEffect(() => {
        setAnswerFormData()
    }, [])

    let toggleTab = tab => {

        if (activeTab !== tab) setActiveTab(tab)

        // clear the file input after re-select it
        if (activeTab === 'fileAttachment')
            document.querySelector('#files').value = null

        // clear the answer Form after re-select it
        if (activeTab === 'answerForm')
            setAnswerFormData()

    }

    let addMessageToTicket = async () => {

        setIsSaving(true)

        /* let { length: attachmentFile } = document.querySelector('#files').files
        if (!attachmentFile || !answerFormData)
            console.log('NO Attachment || Answer Form'); */

        try {

            let filesUrls = await getAttachment(task)

            isDecline ? await declineTicket(filesUrls, note, answerFormData) :
                isComplete ? await completeTicket(filesUrls, note, answerFormData) :
                    await approveTicket(filesUrls, note, answerFormData)

        } catch (error) {
            console.log(error)

        } finally {
            setIsSaving(false)
            toggle()
            setNote('')
        }

    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            title={t('add_message')}
            size="md"
            isSaving={isSaving}
            footerBtns={[{
                title: t('done'),
                onClick: addMessageToTicket,
            }]}
        >
            <div style={{ minHeight: '50vh' }} className='p-3' >

                <Row className="mr-3 ml-3">

                    <Col md="12">
                        <FormGroup >
                            <InputGroup >
                                <Input
                                    type="text"
                                    name="note"
                                    id={task.id}
                                    placeholder={t('reason_or_message')}
                                    autoComplete="off"
                                    defaultValue={_.get(task, 'message', '')}
                                    onChange={e => setNote(e.target.value)}
                                />
                                <InputGroupAddon addonType="append" className="info" className="bg-transparent">
                                    <InputGroupText><i className="nc-icon nc-simple-remove" onClick={() => setNote('')} /></InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </FormGroup>
                    </Col>

                </Row>

                <div className='mt-3'>

                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                onClick={() => toggleTab('fileAttachment')}
                            >{t('add_file_attachment')}</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                onClick={() => {
                                    toggleTab('answerForm')
                                    requestModalRef.current.toggleModal()
                                }}
                            >{t('add_answer_form')}</NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab} className="mx-3">

                        {/* File attchment tab */}
                        <TabPane tabId="fileAttachment">
                            <Row>
                                <Col sm="10">
                                    <div className='mt-5 mb-5'>
                                        <input
                                            type='file'
                                            id='files'
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        {/* answerForm Tab */}
                        <TabPane tabId="answerForm">
                            <Row>
                                <Col sm="10">
                                
                                    {/* requests list & froms modal */}
                                    <RequestsForms
                                        ref={requestModalRef}
                                        isAnswerForm={true}
                                        setAnswerFormData={(formData) => setAnswerFormData(formData)}
                                    />

                                    {/* display the answer form fields */}
                                    {answerFormData && (
                                        <>
                                            <Form
                                                inputs={answerFormData}
                                                readOnly={true}
                                            />

                                            <Button
                                                className='neutral'
                                                color='danger'
                                                size="sm"
                                                onClick={() => setAnswerFormData()}
                                            >
                                                {t('remove_the_answer_form')}
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>

                        </TabPane>

                    </TabContent>

                </div>

            </div>

        </Modal>
    )
}

export default MessageModal

export async function getAttachment(task) {

    let docPath = `tickets/${task.id}`

    // save the ticket files
    let pfInput = document.querySelector('#files').files

    let files = Array.prototype.slice.call(pfInput)
    let filesUrls
    if (!_.isEmpty(files)) {

        // Array of "Promises"
        let urls = await Promise.all(
            files.map(file => getImageUrl(file, `${docPath}/${file.name}`))
        )

        filesUrls = _.map(urls, (url, idx) => ({
            name: files[idx].name,
            url: url
        }))
    }
    return filesUrls
}
